/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: Header.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  05.07.22 10:13 am.
 * Last modified: 05.07.22 10:13 am.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { addBuildHash } from '../api/helpers';
import { useSettings } from '../contexts/SettingsContext';
import { useTranslator } from '../contexts/TranslatorContext';
import HeaderTitle from './HeaderTitle';
import { IHeaderTitleProps } from './HeaderTitle';

const Header = ({ count, icon, label, isViewingAll, onClickViewAll, onClickIcon }: IHeaderProps) => {
    const translate = useTranslator();
    const [settings] = useSettings();

    return (
        <div className="egt_section_header">
            <HeaderTitle icon={icon} label={label} selected={isViewingAll} count={count} onClickIcon={onClickIcon} />
            {!isViewingAll && (
                <div className="egt_section_header_more_games" onClick={onClickViewAll}>
                    <span>
                        {' '}
                        {translate('View All')} ({count}){' '}
                        <img
                            className="view-all-icon rotated-270"
                            src={`${addBuildHash(settings.host + '/assets/portal/ui/arrow.svg')}#chevron`}
                            alt=""
                        />
                    </span>
                </div>
            )}
        </div>
    );
};

export interface IHeaderProps extends IHeaderTitleProps {
    count: number;
    isViewingAll?: boolean;
    onClickViewAll?: () => void;
    onClickIcon?: () => void;
}

export default Header;
